import React, { Component } from 'react';

import { SelectorOption } from 'components/pages/ProductDetails/types/SelectorOption';
import { fontFamilies } from 'components/UI/Font';

export class SizeSelectorDesktop extends Component<
  {
    isOutOfStock?: boolean;
    selectSize: (optionValue: string) => void;
    selectedOption: SelectorOption;
    selectorOptions: SelectorOption[];
    selectorTitleText: string;
    showSelectSizeBadge: boolean;
    sizeSystemAlias: string;
    trackOnSelectorClick: () => void;
  },
  { open: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  componentDidUpdate(_, prevState) {
    const { open } = this.state;
    if (open && !prevState.open) {
      document.addEventListener('click', this.onOutsideClick);
    } else if (!open && prevState.open) {
      document.removeEventListener('click', this.onOutsideClick);
    }
  }

  onOutsideClick = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      isOutOfStock,
      trackOnSelectorClick,
      selectedOption,
      selectSize,
      selectorOptions,
      selectorTitleText,
      showSelectSizeBadge,
      sizeSystemAlias,
    } = this.props;

    const { open } = this.state;

    let label = isOutOfStock ? 'sold out' : selectorTitleText;
    if (selectedOption) {
      label = `Selected Size: ${selectedOption.size} ${sizeSystemAlias}`;
    }

    return (
      <>
        <div
          className={`container desktop ${isOutOfStock ? 'inactive' : ''} ${open ? 'open' : 'inactive'}`}
          onClick={() => {
            trackOnSelectorClick();
            this.setState({ open: !open });
          }}
        >
          <div className="size_selector">
            <span className={`${isOutOfStock ? 'out_of_stock_text' : ''}`} data-prefix_text="Selected size:">
              {label}
            </span>
            {showSelectSizeBadge && <span className="badge badge-important">!</span>}
            <i className="icon-angle-down" />
            <i className="icon-angle-up" />
          </div>
          <ul className="size_options">
            {selectorOptions.map((option, index) => (
              <li
                key={`size_option_${option.size}`}
                className={`size_system_id_${index} ${option.disabled ? 'unavailable' : ''}`}
                onClick={() => {
                  if (!option.disabled) {
                    selectSize(option.value);
                    setTimeout(() => this.setState({ open: false }));
                  }
                }}
              >
                <span className="product_size_size">
                  {`${option.size}${sizeSystemAlias ? ` ${sizeSystemAlias}` : ''}${
                    option.disabled ? ' (Not Available)' : ''
                  }`}
                </span>
                {option.numberAvailable === 1 && <span className="only-one-left-selector">Only 1 left*</span>}
              </li>
            ))}
          </ul>
        </div>

        <style jsx>{`
          .container {
            position: relative;
            width: 100%;
          }

          .container * {
            font-size: 13px;
          }

          .only-one-left-selector {
            color: #f25c5e;
            font-family: ${fontFamilies.bold};
          }

          .badge.badge-important {
            margin-left: 5px;
          }

          .size_options {
            z-index: 1;
            margin: 0;
            position: absolute;
            display: none;
            top: 35px;
            border: 1px solid #000;
            cursor: pointer;
            background-color: #fff;
            box-shadow: 3px 3px 6px #e3e3e3;
            width: 99.5%;
          }
          .container.open .size_options {
            display: block;
          }

          .size_options li {
            padding: 15px;
            display: flex;
            justify-content: space-between;
          }

          .size_options li:hover {
            background-color: #f0f0f0;
          }

          .size_selector {
            box-shadow: 3px 3px 6px #e3e3e3;
            padding: 8px 15px;
            font-size: 15px;
            cursor: pointer;
            border-radius: 4px;
            border: 1px solid #000;
          }

          .size_selector i {
            position: absolute;
            right: 15px;
            font-size: 18px;
          }

          .size_selector i.icon-angle-up {
            display: none;
          }
          .container.open i.icon-angle-up {
            display: inline-block;
          }
          .container.open i.icon-angle-down {
            display: none;
          }

          .size_guide_link_cnt {
            margin-right: 120px;
          }

          span.out_of_stock_text {
            color: #c30016;
            font-size: 15px;
            line-height: 18px;
            text-transform: uppercase;
            text-align: center;
          }
        `}</style>
      </>
    );
  }
}
